import React from 'react'
import PropTypes from 'prop-types'
import { withOutboundLink } from 'LiveBoard/hocs'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES } from 'shared/helpers/AccessibilityHelper'

import get from 'lodash/get'

class LinkCategory extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isHover: false }
  }

  onMouseEnter = (event) => {
    event.stopPropagation()
    this.setState({ isHover:true })
  }

  onMouseLeave = (event) => {
    event.stopPropagation()
    this.setState({ isHover:false })
  }

  onClickCategory = () => {
    this.props.onOpenOutboundLink(this.props.category.url)
  }

  render() {
    const { category, categoryCSS, categoryTheme } = this.props
    const hoveredCategoryCSS =  get(categoryCSS, 'hover' ,{})
    const defaultCategoryCSS =  get(categoryCSS, 'default' ,{})
    const accessibilityClass = categoryTheme === 'classic' ? ACCESSIBILITY_CLASSES.main : ACCESSIBILITY_CLASSES.withOffset

    return (
      <div style={this.state.isHover ? hoveredCategoryCSS.tab : defaultCategoryCSS.tab}
           onMouseEnter={this.onMouseEnter}
           onMouseLeave={this.onMouseLeave}
           className={`category ${accessibilityClass}`}
           onClick={this.onClickCategory}
           onKeyDown={triggerClickOnEnter}
           tabIndex={0}
           role="button">
        {category.name}
      </div>
    )
  }

}

LinkCategory.propTypes = {
  category: PropTypes.object,
}

export default withOutboundLink(LinkCategory)